// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/js/" + {"229":"npm.gsap","321":"contact-view","372":"home-view","787":"about-us-view","812":"npm.swiper","885":"projects-view","908":"partners-view"}[chunkId] + ".js";
};